export default "__VITE_ASSET__uj$ZWujH__"